import React from "react";
import { FiSmartphone, FiTablet, FiWatch } from "react-icons/fi";
import { CATEGORY_ROUTE } from "../../../routes/constant";
import { Link } from "react-router-dom";

const CategoryGrid = ({ categories, isDarkMode }) => {
  if (!categories || categories.length === 0) return null;

  const getCategoryIcon = (category) => {
    if (category.image) {
      return (
        <img
          src={category.image}
          alt={category.name}
          className="object-contain w-12 h-12 md:w-16 md:h-16"
        />
      );
    }

    if (category.name?.includes("Phone"))
      return <FiSmartphone size={28} className="md:text-[36px]" />;
    if (category.name?.includes("Tablet"))
      return <FiTablet size={28} className="md:text-[36px]" />;
    if (category.name?.includes("Watch"))
      return <FiWatch size={28} className="md:text-[36px]" />;
    return <FiSmartphone size={28} className="md:text-[36px]" />;
  };

  return (
    <section className="mb-3 md:mb-8">
      {/* Card Container with Distinct Border */}
      <div 
        className={`
          relative p-3 overflow-hidden rounded-2xl md:rounded-2xl md:p-6
          border-2 md:border
          ${isDarkMode 
            ? "border-gray-700 bg-gray-800/30" 
            : "border-gray-200 bg-white shadow-sm"
          }
        `}
      >
        {/* Gradient Background - Only on Mobile */}
        <div 
          className={`
            absolute inset-0 md:hidden 
            ${isDarkMode 
              ? "bg-gradient-to-br from-gray-800 via-gray-900 to-gray-950" 
              : "bg-gradient-to-br from-green-200 via-green-400 to-emerald-100"
            }
          `}
        ></div>
        
        {/* Solid Background - Only on Desktop (slightly different from body) */}
        <div 
          className={`
            absolute inset-0 hidden md:block
            ${isDarkMode ? "bg-gray-800/90" : "bg-gray-50"}
          `}
        ></div>

        {/* Content */}
        <div className="relative z-10">
          {/* Header */}
          <h2
            className={`
            text-sm font-semibold mb-3 md:text-lg md:mb-5
            ${isDarkMode ? "text-white" : "text-gray-800"}
          `}
          >
            Sell by Category
          </h2>

          {/* 3-Grid Layout */}
          <div className="grid grid-cols-4 gap-2 md:gap-4">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={CATEGORY_ROUTE(category.slug)}
                className={`
                  flex flex-col items-center text-center p-2 rounded-xl
                  transition-all duration-200
                  ${
                    isDarkMode
                      ? "bg-gray-800/90 backdrop-blur-sm hover:bg-gray-700 border border-gray-600"
                      : "bg-white/90 backdrop-blur-sm hover:bg-white border border-gray-200"
                  }
                  md:py-5 md:px-3 
                  ${isDarkMode 
                    ? "md:bg-gray-800 md:hover:bg-gray-700 md:border md:border-gray-600 md:shadow-lg" 
                    : "md:bg-white md:hover:bg-gray-50 md:border md:border-gray-200 md:shadow-md"
                  }
                `}
              >
                <div
                  className={`
                  flex items-center justify-center mb-2 w-12 h-12 md:w-20 md:h-20
                  ${isDarkMode ? "text-green-400" : "text-green-600"}
                  ${isDarkMode 
                    ? "md:text-gray-300" 
                    : "md:text-gray-700"
                  }
                `}
                >
                  {getCategoryIcon(category)}
                </div>
                <h3
                  className={`
                    font-medium text-[11px] leading-tight md:text-sm md:font-medium
                    ${isDarkMode ? "text-white" : "text-gray-800"}
                    ${isDarkMode 
                      ? "md:text-gray-300" 
                      : "md:text-gray-700"
                    }
                  `}
                >
                  {category.display_name || category.name || ""}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;